import { render, staticRenderFns } from "./FinancialConsumers.vue?vue&type=template&id=72365838"
import script from "./FinancialConsumers.vue?vue&type=script&lang=js"
export * from "./FinancialConsumers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports